type ClassValue = string | number | false | null | undefined | ClassValue[];

/** Junta classes condicionais. Local para não adicionar dependência por 8 linhas. */
export function cn(...values: ClassValue[]): string {
  const output: string[] = [];

  for (const value of values) {
    if (!value) continue;
    if (Array.isArray(value)) {
      const nested = cn(...value);
      if (nested) output.push(nested);
    } else {
      output.push(String(value));
    }
  }

  return output.join(' ');
}
